const activeButtonEquipStatusBtn = {
  true: 'Inactivate',
  false: 'Reactivate',
  label: 'Equipment'
};

export default activeButtonEquipStatusBtn;
